import React from "react";
import LegalLayout from "@/components/LegalLayout";
import { site } from "@/config/site";

export default function Refund() {
  return (
    <LegalLayout title="Refund &amp; Cancellation Policy" updatedOn="April 2026">
      <p className="italic text-navy/60">
        This policy is drafted for Razorpay activation. Please review before
        going live.
      </p>

      <h2>1. Free trial</h2>
      <p>
        We offer a 14-day free trial. No card is required to start the trial.
        You will not be charged until you decide to continue with a paid plan.
      </p>

      <h2>2. Paid plans</h2>
      <p>
        Paid plans at VaultSafe are billed annually in advance. Annual plans are
        non-refundable once activated. You can cancel your plan at any time to
        prevent it from renewing at the end of the term.
      </p>

      <h2>3. How to cancel</h2>
      <p>
        Send a written request from your registered email address to{" "}
        <a href={`mailto:${site.email}`}>{site.email}</a> asking to cancel.
        Please include your account details. We will confirm your cancellation
        within two business days.
      </p>

      <h2>4. What happens to your data</h2>
      <p>
        After cancellation your backup data is retained for 30 days so that you
        can export it or reactivate. Our team will help you export your data
        during this window. After 30 days the data is permanently deleted.
      </p>

      <h2>5. Refunds we do offer</h2>
      <ul>
        <li>
          <strong>Duplicate payments</strong> — refunded in full within 5–7
          business days to the original payment method.
        </li>
        <li>
          <strong>Failure to activate service</strong> — if we are unable to
          install and activate service within 15 business days of your payment,
          you may request a full refund.
        </li>
      </ul>

      <h2>6. Refund processing time</h2>
      <p>
        Approved refunds are processed within 5–7 business days to the original
        payment method used at checkout.
      </p>

      <h2>7. Not refundable</h2>
      <ul>
        <li>
          Paid plan fees, once service has been activated, are non-refundable.
        </li>
        <li>Setup fees, if any, are non-refundable once setup is delivered.</li>
        <li>
          Any losses claimed to result from a backup or restore issue — see the
          limitation of liability clause in our{" "}
          <a href="/terms" className="underline">Terms &amp; Conditions</a>.
        </li>
      </ul>

      <h2>8. Contact for refund requests</h2>
      <p>
        All refund requests should be sent to{" "}
        <a href={`mailto:${site.email}`}>{site.email}</a> from your registered
        email address, with your account details and the reason for the request.
      </p>
    </LegalLayout>
  );
}
